import type {
    ComposableOptionsBase
} from '~/types';
import type { NitroFetchOptions } from 'nitropack';
import { useApiUtils } from 'x1-base/composables';
import { useCustomFetch } from '~/composables';
import type { NuxtError } from '#app';


export interface UseAccountCreditOptions extends ComposableOptionsBase {}
export function useAccountCredit(options: Partial<UseAccountCreditOptions> = {}) {
    const apiBasePath = '/v1/account-credit-transactions';
    const useApiUtilsObj = useApiUtils();
    const $_fetch = useCustomFetch();

    async function transferCredit(uid: string, amount: number): Promise<void | NuxtError> {
        const url = `${apiBasePath}/transfer/`;
        const config: NitroFetchOptions<string> = {
            method: 'POST',
            body: {
                entity_uid: uid,
                amount
            }
        };

        try {
            return await $_fetch<void>(url, config);
        } catch (err) {
            return useApiUtilsObj.getNuxtErrorObj(err);
        }
    }

    return {
        transferCredit
    };
}
